// LanguageSelectionPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './LanguageSelectionPage.css';

import flagES from '../../statics/Banderas/ESP.png';
import flagEN from '../../statics/Banderas/ENG.png';
import flagIT from '../../statics/Banderas/ITA.png';
import flagIS from '../../statics/Banderas/IS.png';
import flagDE from '../../statics/Banderas/ALE.png';

import flagESHover from '../../statics/Banderas/ESP-hover.png';
import flagENHover from '../../statics/Banderas/ENG-hover.png';
import flagITHover from '../../statics/Banderas/ITA-hover.png';
import flagISHover from '../../statics/Banderas/IS-hover.png';
import flagDEHover from '../../statics/Banderas/ALE-hover.png';

function LanguageSelectionPage() {

  const navigate = useNavigate();
  const { setLanguage } = useLanguage();

  const [showHoverES, setShowHoverES] = useState(false);
  const [showHoverEN, setShowHoverEN] = useState(false);
  const [showHoverIT, setShowHoverIT] = useState(false);
  const [showHoverDE, setShowHoverDE] = useState(false);
  const [showHoverIS, setShowHoverIS] = useState(false);

  const handleLanguageSelect = (language) => {
    setLanguage(language);
    navigate('/curriculum');
  };

  return (

    <div className="language-page flex flex-col items-center justify-center min-h-screen px-6 py-10">

      {/* Encabezado */}

      <div className="text-center mb-8">

        <div className="text-4xl mb-2 animate-pulse">
          🌍
        </div>

        <h1 className="text-white text-3xl sm:text-4xl font-bold leading-tight">
          Choose your language
        </h1>

        <p className="text-white/60 text-base mt-2">
          Tap your language to continue
        </p>

      </div>

      {/* Español */}

      <div
        onMouseEnter={() => setShowHoverES(true)}
        onMouseLeave={() => setShowHoverES(false)}
        onClick={() => handleLanguageSelect('es')}
        className="cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-95 mb-4"
      >

        <img
          src={showHoverES ? flagESHover : flagES}
          alt="Español"
          className="w-[330px] sm:w-[360px] md:w-[410px] h-auto drop-shadow-2xl select-none"
          draggable="false"
        />

      </div>

      {/* English */}

      <div
        onMouseEnter={() => setShowHoverEN(true)}
        onMouseLeave={() => setShowHoverEN(false)}
        onClick={() => handleLanguageSelect('en')}
        className="cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-95 mb-4"
      >

        <img
          src={showHoverEN ? flagENHover : flagEN}
          alt="English"
          className="w-[330px] sm:w-[360px] md:w-[410px] h-auto drop-shadow-2xl select-none"
          draggable="false"
        />

      </div>

      {/* Italiano */}

      <div
        onMouseEnter={() => setShowHoverIT(true)}
        onMouseLeave={() => setShowHoverIT(false)}
        onClick={() => handleLanguageSelect('it')}
        className="cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-95 mb-4"
      >

        <img
          src={showHoverIT ? flagITHover : flagIT}
          alt="Italiano"
          className="w-[330px] sm:w-[360px] md:w-[410px] h-auto drop-shadow-2xl select-none"
          draggable="false"
        />

      </div>

      {/* Polski */}

      <div
        onMouseEnter={() => setShowHoverDE(true)}
        onMouseLeave={() => setShowHoverDE(false)}
        onClick={() => handleLanguageSelect('de')}
        className="cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-95 mb-4"
      >

        <img
          src={showHoverDE ? flagDEHover : flagDE}
          alt="Polski"
          className="w-[330px] sm:w-[360px] md:w-[410px] h-auto drop-shadow-2xl select-none"
          draggable="false"
        />

      </div>

      {/* Íslensku */}

      <div
        onMouseEnter={() => setShowHoverIS(true)}
        onMouseLeave={() => setShowHoverIS(false)}
        onClick={() => handleLanguageSelect('is')}
        className="cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-95"
      >

        <img
          src={showHoverIS ? flagISHover : flagIS}
          alt="Íslensku"
          className="w-[330px] sm:w-[360px] md:w-[410px] h-auto drop-shadow-2xl select-none"
          draggable="false"
        />

      </div>

    </div>

  );

}

export default LanguageSelectionPage;